import { render } from "./Price.vue?vue&type=template&id=2743081a&scoped=true"
import script from "./Price.vue?vue&type=script&lang=js"
export * from "./Price.vue?vue&type=script&lang=js"

import "./Price.vue?vue&type=style&index=0&id=2743081a&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/Mosolysziget/Mosolysziget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2743081a"]])

export default __exports__